<div class="flex flex-row gap-2 items-center">
  <flow-form-input class="w-full" [formControl]="control" type="email">
    <div suffix>
      <flow-button *ngIf="canRemove" class="mb-1 mr-1" theme="light" (onClick)="onRemove()" [disabled]="disabled">
        <app-icon iconName="x" size="md" stroke="#202020"></app-icon>
      </flow-button>
    </div>
  </flow-form-input>
</div>
